var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, makeObservable } from 'mobx';
import { bound } from '../../../../utils/decorators/basic';
import { runtime } from '../../Runtime';
export class BrowserWordlist {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get browserRuntime() {
        return this.parent;
    }
    wordList = observable.map();
    async fetchWordlist(listName) {
        if (this.wordList.has(listName))
            return;
        runtime.runtimeScheduler.addToNextStateChange(() => this.wordList.set(listName, []));
        const response = await fetch(`/static/wordlist/${listName}.txt`);
        const responseText = await response.text();
        const words = responseText.split('\n');
        runtime.runtimeScheduler.addToNextStateChange(() => {
            this.wordList.set(listName, words);
        });
    }
}
__decorate([
    observable.shallow
], BrowserWordlist.prototype, "wordList", void 0);
__decorate([
    bound
], BrowserWordlist.prototype, "fetchWordlist", null);
